<div class="header">
	<div class="icon">
		<img
			[src]="iconImage"
			[attr.alt]="title ? title.toLowerCase() : ''"
			*ngIf="!disabled"
		/>
		<img
			[src]="iconImageDisabled"
			[attr.alt]="title ? title.toLowerCase() : ''"
			*ngIf="disabled"
		/>
	</div>

	<div *ngIf="title" class="title">
		<div class="original-price" [innerHtml]="originalPrice"></div>
		<div class="title-cost" [innerHtml]="title"></div>
		<div class="title-mth">/mth</div>
	</div>
</div>
<div class="details">
	<div
		*ngIf="marketing"
		class="marketing-text"
		[ngClass]="marketing.textDecoration"
		[innerHtml]="marketing.text"
	></div>
	<div class="descriptions" *ngFor="let description of descriptions">
		<div>
			<img src="assets/img/icons/purple-plus.svg" *ngIf="!disabled" />
		</div>
		<div><img src="assets/img/icons/grey-plus.svg" *ngIf="disabled" /></div>
		<span class="price-text">{{ description }}</span>
	</div>
</div>
<div class="toggle-icon"></div>
